import { render, staticRenderFns } from "./ToSScarlet.vue?vue&type=template&id=585cddc7"
import script from "./ToSScarlet.vue?vue&type=script&lang=js"
export * from "./ToSScarlet.vue?vue&type=script&lang=js"
import style0 from "./ToSScarlet.vue?vue&type=style&index=0&id=585cddc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports